module.exports = __webpack_public_path__ + "static/img/2-nei-ying.4118210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2-nei-ying.png
// module id = 0fuE
// module chunks = 1